import { LANGUAGES, SupportedLanguage } from "@next-platform/client-common-core";

export function stripLanguagePrefix(pathname: string): string {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length > 0 && LANGUAGES[segments[0] as SupportedLanguage]) {
    return "/" + segments.slice(1).join("/") || "/";
  }
  return pathname;
}
